import script from "./HighLow.vue?vue&type=script&lang=js"
export * from "./HighLow.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__